import type { FC } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { PRODUCT_OPTIONS, type Product } from './MembersDashboardService'
import { BLUE } from '~/shared/lib/theme'

interface Props {
  value: Product
  onChange: (product: Product) => void
}

// Segmented control for the Product scope. Selected option is filled blue.
const ProductToggle: FC<Props> = ({ value, onChange }) => (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={value}
    onChange={(_e, next: Product | null) => next && onChange(next)}
    aria-label="Product"
    sx={{
      bgcolor: 'background.default',
      borderRadius: 2,
      '& .MuiToggleButton-root': { textTransform: 'none', px: 2, borderColor: 'grey.100' },
      // Round the outer corners of the segmented group (inner edges stay square).
      '& .MuiToggleButtonGroup-grouped:first-of-type': {
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
      },
      '& .MuiToggleButtonGroup-grouped:last-of-type': {
        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,
      },
      '& .MuiToggleButton-root.Mui-selected': {
        bgcolor: BLUE[600],
        color: 'common.white',
        '&:hover': { bgcolor: BLUE[800] },
      },
    }}
  >
    {PRODUCT_OPTIONS.map(opt => (
      <ToggleButton key={opt.value} value={opt.value}>
        {opt.label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
)

export default ProductToggle
